import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { ThemeContext } from '../../../context';
import { renderAbsoluteAssets } from '../../../util/renderHelpers';
import { Z_INDEX_MAP, Z_INDEX_HERO_IMAGE_KEY } from '../../../util/zIndexConstants';

const Hero = ({
  title,
  imageUrl,
  className,
}: {
  title?: string;
  imageUrl?: string;
  className?: string;
}): JSX.Element => {
  const {
    components: { H1 },
    homepage: {
      hero: { assets },
    },
  } = useContext(ThemeContext);

  const HeroContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    text-align: center;
    min-height: 700px;
  `;

  const OverlayTitle = styled(H1)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `;

  const HeroImage = styled.div<{ backgroundImage?: string }>`
    ${({ backgroundImage }) =>
      backgroundImage ? `background-image: url(${backgroundImage}); background-size: cover;` : ''}
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: ${Z_INDEX_MAP[Z_INDEX_HERO_IMAGE_KEY]};
  `;

  const heroImage = imageUrl;

  return (
    <HeroContainer className={className}>
      <HeroImage backgroundImage={heroImage} />
      <OverlayTitle>{title}</OverlayTitle>
      {renderAbsoluteAssets(assets)}
    </HeroContainer>
  );
};

export default Hero;
